import * as actionTypes from "../actions/report";
import {
  openFile,
  notifySuccess,
  notifyError,
  notifyInfo,
  toUIDate,
} from "../../../components/Utils";

const { reportInterval } = actionTypes.getDefaultReportInterval();
export const initialState = {
  loading: false,
  loginBehaviorReport: [],
  loginBehaviorReportInterval: reportInterval,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    // get mytechie interval report
    case actionTypes.LOAD_MYTECHIE_REPORT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.LOAD_MYTECHIE_REPORT_SUCCESS: {
      if (action.result.filePath) {
        notifySuccess({
          summary: `MyTechie-Report (CSV) herunterladen`,
          detail: `Der Report wurde erfolgreich als CSV-Datei generiert und kann heruntergeladen werden!`,
        });
        openFile(action.result.filePath);
      } else {
        const [fromDate, toDate] = action.interval || [];
        notifyInfo({
          summary: `MyTechie-Report (CSV) herunterladen`,
          detail: `Für den Zeitraum (${toUIDate(fromDate, "YYYY-MM-DD")} - ${toUIDate(toDate, "YYYY-MM-DD")}) gibt es keine Daten!`,
        });
      }
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.LOAD_MYTECHIE_REPORT_FAILURE:
      notifyError({
        summary: `MyTechie-Report (CSV) herunterladen`,
        detail: `Der Report konnte nicht generiert werden!`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };

    // get login behavior report
    case actionTypes.LOAD_LOGIN_BEHAVIOR_REPORT:
      return {
        ...state,
        loading: true,
        loginBehaviorReportInterval: action.reportInterval || reportInterval,
      };
    case actionTypes.LOAD_LOGIN_BEHAVIOR_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        loginBehaviorReport: action.result,
      };
    case actionTypes.LOAD_LOGIN_BEHAVIOR_REPORT_FAILURE:
      notifyError({
        summary: `Login Verhalten Report laden`,
        detail: `Der Report konnte nicht geladen werden!`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };

    // export login behavior report
    case actionTypes.EXPORT_LOGIN_BEHAVIOR_REPORT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.EXPORT_LOGIN_BEHAVIOR_REPORT_SUCCESS: {
      if (action.result.filePath) {
        notifySuccess({
          summary: `Login Verhalten Report (CSV) herunterladen`,
          detail: `Der Report wurde erfolgreich als CSV-Datei generiert und kann heruntergeladen werden!`,
        });
        openFile(action.result.filePath);
      } else {
        notifyInfo({
          summary: `Login Verhalten Report (CSV) herunterladen`,
          detail: `Es gibt keine Daten für den Login Verhalten Report!`,
        });
      }
      return {
        ...state,
        loading: false,
      };
    }
    case actionTypes.EXPORT_LOGIN_BEHAVIOR_REPORT_FAILURE:
      notifyError({
        summary: `Login Verhalten Report (CSV) herunterladen`,
        detail: `Der Report konnte nicht generiert werden!`,
      });
      return {
        ...state,
        loading: false,
        error: action.result,
      };

    default:
      return null;
  }
};
